const COLLECTION_NAME_SEPARATOR = ', ';

export const joinCollectionNames = (names: string[]): string =>
  names.join(COLLECTION_NAME_SEPARATOR);

export const joinCollectionNamesUpTo = (names: string[], maxLength: number): string => {
  const fitting: string[] = [];

  for (const name of names) {
    if (joinCollectionNames([...fitting, name]).length > maxLength) {
      break;
    }
    fitting.push(name);
  }

  return joinCollectionNames(fitting);
};
